export const headerHeight = 96;
export const footerHeight = 40;
